"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableCellValidator = void 0;
const lodash_1 = require("lodash");
const table_cell_kinds_enum_1 = require("../../models/tables/table-cell-kinds.enum");
class TableCellValidator {
    constructor(cellData, headerColumn) {
        this.cellData = cellData;
        this.headerColumn = headerColumn;
    }
    hasAnyData() {
        return (!!this.cellData.value ||
            !(0, lodash_1.isEmpty)(this.cellData.photos) ||
            !(0, lodash_1.isEmpty)(this.cellData.attachments) ||
            !(0, lodash_1.isEmpty)(this.cellData.signatures));
    }
    hasCompleteData() {
        return (!!this.cellData.value ||
            !(0, lodash_1.isEmpty)(this.cellData.photos) ||
            !(0, lodash_1.isEmpty)(this.cellData.attachments) ||
            !(0, lodash_1.isEmpty)(this.cellData.signatures) ||
            this.cellData.kind === table_cell_kinds_enum_1.TableCellKinds.PrefilledText ||
            this.headerColumn.kind === table_cell_kinds_enum_1.TableCellKinds.PrefilledText);
    }
    isValid() {
        if (this.headerColumn.isRequired && !this.hasCompleteData()) {
            return false;
        }
        return true;
    }
    invalidDescription() {
        if (this.headerColumn.isRequired && !this.hasCompleteData()) {
            return 'required';
        }
        if (!this.isValid()) {
            return 'invalid';
        }
        return '';
    }
}
exports.TableCellValidator = TableCellValidator;
